import axios from "axios";


export class ViewerService{
    static serverURL = `${process.env.VUE_APP_HOST_API_BACKEND || "/api/dkbackend"}`;

    static getALLViewer() {
        let dataURL = `${this.serverURL}/viewers`;
        console.log('dataURL.usuario');
         console.log(dataURL);
            return axios.get(dataURL);
           
    }
    
    static getViewer(viewerId){
        let dataURL = `${this.serverURL}/viewer/${viewerId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static getViewerVSL_Id(vslId){
        let dataURL = `${this.serverURL}/viewerVSL/${vslId}`;
        // console.log('dataURL');
        // console.log(dataURL);
            return axios.get(dataURL);
    }
    static createViewer(viewer){
        let dataURL = `${this.serverURL}/viewer/`;
        console.log('dataURL.viewer');
        console.log(dataURL,viewer);
        return axios.post(dataURL,viewer);
    }
       

    static updateViewer(viewer, vslId){
        let dataURL = `${this.serverURL}/viewer/${vslId}`;
        return axios.put(dataURL, viewer)
    }

    static deleteViewer(viewerId){
        let dataURL = `${this.serverURL}/viewer/${viewerId}`;
        return axios.delete(dataURL);
    }

    
       


}